import type { UserRole } from './types';

export const authAllowedRoles: UserRole[] = [
  'employer',
  'supervisor',
  'partner',
];
